// address_1〜5用のフォーム(-> ただのtextfieldにリファクタリング)
import { memo } from 'react'
import { css } from '@emotion/react'
import FormLabel from '~/components/finalForms/atoms/FormLabel'
import { Field } from 'react-final-form'
import RenderTextField from '../atoms/RenderTextField';
import colorPalette from '~/theme/colorPalette.js';

const TextField = ({label, id, placeholder = null, validate, must }) => {

  return(
    <div css={inputUnit}>
      <FormLabel must={must}>{label}</FormLabel>
      <div css={styledInput}>
        <div css={styledAddress}>
          <Field
            id={id}
            name={id}
            placeholder={placeholder}
            component={RenderTextField}
            css={inputForm}
            validate={validate}
          />
        </div>
      </div>
    </div>
  )
}

export default memo(TextField);

const inputUnit = css`
  display: flex;
  flex-direction: column;
`;

const styledInput = css`
  display: flex;
  justify-content: start;
  text-align: right;
  margin: 0 0.5rem 1rem 0;
  .error{
    font-size: 1.3rem;
    color: ${colorPalette.orange};
    font-weight: bold;
  }
  >button{
    min-width: 120px;
    border-radius: 30px;
    height: 25px;
    margin-top: auto;
  }
`;

const inputForm = css`
  background-color: ${colorPalette.background.lightgray};
  border-radius: 10px;
  margin: 0;
  &:before {
    border-bottom: none;
  }
  &:after {
    border-bottom: none;
  }
  input:-webkit-autofill {
    transition: background-color 5000s ease-in-out 0s !important;
  }
`;

const styledAddress = css`
  width: 100%;
`;
